import React from 'react';

/**
 * Prev / Page N of M / Next. Renders nothing at a single page.
 * Shared by the Road and Water catalog modes.
 */
export default function CatalogPager({ currentPage, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;
  return (
    <div className="d-flex justify-content-center align-items-center mt-3">
      <button
        className="btn btn-sm btn-outline-secondary mr-2"
        disabled={currentPage <= 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        <i className="fa-sharp fa-regular fa-chevron-left mr-1"></i> Prev
      </button>
      <span className="mx-2 text-muted" style={{ fontSize: '14px' }}>
        Page {currentPage} of {totalPages}
      </span>
      <button
        className="btn btn-sm btn-outline-secondary ml-2"
        disabled={currentPage >= totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        Next <i className="fa-sharp fa-regular fa-chevron-right ml-1"></i>
      </button>
    </div>
  );
}
